// Canonical 2f "Repeater" grid, DESIGN_LANGUAGE §7. Lives apart from the components that draw it
// (rally-mark.tsx, loading/rally-loader.tsx) so both read the same bars and neither file mixes a
// data export with its component export.
export interface MarkBar {
  x: number
  w: number
  h: number
  center?: boolean
}

export const MARK_VIEW_BOX = { width: 66, height: 56 } as const

export const MARK_BARS: MarkBar[] = [
  { x: 0, w: 8, h: 18 },
  { x: 14, w: 8, h: 32 },
  { x: 28, w: 10, h: 56, center: true },
  { x: 44, w: 8, h: 32 },
  { x: 58, w: 8, h: 18 }
]
